/**
 * 로그인 직후 서비스 종료 안내 페이지로 1회 이동했는지 기록하는 localStorage 키.
 * 로그인 화면에 진입할 때(일반 로그아웃·토큰 만료 로그아웃 모두 로그인 화면을 거친다) 지워서
 * 로그인마다 한 번씩 안내가 뜨고, 같은 로그인 세션 안에서는 새 탭을 열어도 다시 뜨지 않게 한다.
 */
export const SERVICE_NOTICE_SHOWN_KEY = 'wepin:service_notice_shown'
